"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nmiles2km = exports.miles2km = exports.miles2nmiles = exports.nmiles2miles = exports.ft2m = exports.in2mm = exports.km2nmiles = exports.km2miles = exports.m2ft = exports.mm2in = void 0;
var rounding_1 = require("./rounding");
var DEF_PRECISION = 2;
/* ***  FROM METRIC UNITS  *** */
// mm -> inches
var mm2in = function (val, decimals) { return rounding_1.default(val / 25.4, decimals || DEF_PRECISION); };
exports.mm2in = mm2in;
// m -> ft
var m2ft = function (val, decimals) { return rounding_1.default(val * 3.2808398950131, decimals || DEF_PRECISION); };
exports.m2ft = m2ft;
// km -> miles
// export const km2miles = (val: number, decimals?: number) => round((val / 1.609344), decimals || DEF_PRECISION);
var km2miles = function (val, decimals) { return exports.nmiles2miles(exports.km2nmiles(val, decimals), decimals); };
exports.km2miles = km2miles;
// km -> nautical miles
var km2nmiles = function (val, decimals) { return rounding_1.default(val / 1.852, decimals || DEF_PRECISION); };
exports.km2nmiles = km2nmiles;
/* ***  FROM IMPERIAL UNITS  *** */
// inches -> mm
var in2mm = function (val, decimals) { return rounding_1.default(val * 25.4, decimals || DEF_PRECISION); };
exports.in2mm = in2mm;
// feet -> meters
var ft2m = function (val, decimals) { return rounding_1.default(val / 3.2808398950131, decimals || DEF_PRECISION); };
exports.ft2m = ft2m;
// nautical miles -> miles
var nmiles2miles = function (val, decimals) { return rounding_1.default(val * 1.1507794480235, decimals || DEF_PRECISION); };
exports.nmiles2miles = nmiles2miles;
// miles -> nautical miles
var miles2nmiles = function (val, decimals) { return rounding_1.default(val / 1.1507794480235, decimals || DEF_PRECISION); };
exports.miles2nmiles = miles2nmiles;
// miles -> km
// export const miles2km = (val: number, decimals?: number) => round((val * 1.609344), decimals || DEF_PRECISION);
var miles2km = function (val, decimals) { return exports.nmiles2km(exports.miles2nmiles(val, decimals), decimals); };
exports.miles2km = miles2km;
// nautical miles -> km
var nmiles2km = function (val, decimals) { return rounding_1.default(val * 1.852, decimals || DEF_PRECISION); };
exports.nmiles2km = nmiles2km;
